

export const ParseGetParams = (params: string): {[name: string]: string} => {
    const clean = atob(params.startsWith("?") ? params.substring(1, params.length) : params);
    const output: {[name: string]: string} = {};

    clean.split("&").forEach(set => {
        const [key, ...value] = set.split("=")
        output[key] = value.join("=")
    })
    return output;
}